import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mandate-create',
  templateUrl: './mandate-create.component.html',
  styleUrls: ['./mandate-create.component.scss'],
  standalone: false,
})
export class MandateCreateComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
